import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { PRECIPITATION_LEVELS_IN_ORDER_OF_SEVERITY } from "~/modules/settings/protocol/constants";

import { WeatherReportsProtocolConditionsFragment } from "./fragment.generated";

interface WeatherReportsProtocolSummaryProps {
    protocolVisit: WeatherReportsProtocolConditionsFragment;
}

export function WeatherReportsProtocolSummary({ protocolVisit }: WeatherReportsProtocolSummaryProps) {
    const { t } = useTranslation("project");

    const precipitationKey = PRECIPITATION_LEVELS_IN_ORDER_OF_SEVERITY[protocolVisit.maxPrecipitation];

    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: 2,
                padding: 2,
                borderBottom: theme => `1px solid ${theme.palette.divider}`,
            }}
        >
            <Box>
                <Typography variant="caption" color="textSecondary">
                    {t("projectReviewVisitV2.weatherReportsRoute.temperatureRange")}
                </Typography>
                <Typography>
                    {protocolVisit.minTemperature}°C — {protocolVisit.maxTemperature}°C
                </Typography>
            </Box>
            <Box>
                <Typography variant="caption" color="textSecondary">
                    {t("projectReviewVisitV2.weatherReportsRoute.maxWindforce")}
                </Typography>
                <Typography>{protocolVisit.maxWindForce} Bft</Typography>
            </Box>
            <Box>
                <Typography variant="caption" color="textSecondary">
                    {t("projectReviewVisitV2.weatherReportsRoute.maxPrecipitation")}
                </Typography>
                <Typography>
                    {t(`projectReviewVisitV2.weatherReportsRoute.precipitationLevels.${precipitationKey}`)}
                </Typography>
            </Box>
        </Box>
    );
}
